import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { LoggerService } from '@commoncore/services/logger.service';
import { AppEvents } from '@commoncore/utils/app-events';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { CleverTapEventsService } from './clevertap-events-service';
import { ContextMenuService } from './context-menu.service';
import { LocalStorageSvc } from './localStorage.service';
import { UniversalService } from './universal.service';

@Injectable({
  providedIn: 'root'
})
export class FileOperationsService {
  shareTextxx: any;

  constructor(
    public universalService:UniversalService,
    public loggerService:LoggerService, 
    public http:HttpClient,private cleverTapEventsService :CleverTapEventsService,
    public contextMenuService:ContextMenuService,
    public router:Router,
    public localStorageService : LocalStorageSvc,
    public activatedRoute : ActivatedRoute
    ) { }

  // add to JioCloud
  addtoJioCloud(){
    var self  = this.universalService;
    self.showLoader = true;
    if(self.showPreview && self.selectedNodes.length == 0){
      self.selectedNodes.push(self.selectedFile);
    }
    this.cleverTapEventsService.addtoJioCloudClicked();
    if(this.universalService.userLoggedIn){
      AppEvents.optionSelected.next({addToJC: true});
    }else{
      this.universalService.popUpToBeOpened = "addToJioCloud";
      this.universalService.showLoader = false;
      this.contextMenuService.hideCustomContextMenu();
      this.router.navigate(["/signin"],{queryParamsHandling:'preserve'});
    }
    self.showMobOptionMenu = false;
    if(self.isMobileDevice){
      self.disableModalBackdrop();
    }
  }


  //add to Album
  addToAlbum(){
    this.cleverTapEventsService.addToAlbumClicked(this.universalService.currentTab);
    var self  = this.universalService;
    self.showLoader = true;
    if(self.showPreview && self.selectedNodes.length == 0){
      self.selectedNodes.push(self.selectedFile);
    }
    self.popUpToBeOpened = "addToAlbum";
    self.showMobOptionMenu = false;
    if(self.isMobileDevice){
      self.disableModalBackdrop();
    }
  }

  deleteItem(){
    this.cleverTapEventsService.fileDelete(this.universalService.currentTab)
    this.universalService.popUpToBeOpened = "deletePopUp";
  }

  //move to selected destination
  moveToSelectedPath(){
    this.cleverTapEventsService.fileMove(this.universalService.currentTab);
    this.universalService.selectedFolder = undefined;
    this.universalService.popUpToBeOpened = "movePopUp";
   
  }

  //move to Private Folder root
  moveObjectToPrivateFolder() {
    this.universalService.popUpToBeOpened = "dummy";
    AppEvents.optionSelected.next({moveToPrivateFolder: true})
  }

  moveOutOfPrivateFolder(){
    this.universalService.popUpToBeOpened = "dummy";
    AppEvents.optionSelected.next({moveOutOfPrivateFolder: true})
  }

  //Copy files in Selected path
  copyInSelectedPath(){
    this.universalService.selectedFolder = undefined;
    this.universalService.popUpToBeOpened = "copyPopUp"
  }

  renameObject(){
    this.cleverTapEventsService.fileRename(this.universalService.currentTab)
    this.universalService.popUpToBeOpened = "renamePopUp"
  }


  createShareLink(){
    this.universalService.popUpToBeOpened = "shareLinkPopUp"
  }


  shareWithPeople(){
    this.universalService.popUpToBeOpened = "shareWithPeoplePopUp"
  }

  addFavorite(){
    
    this.universalService.selectedNodes.map(function(obj){
      if(obj["FullObject"]){
        obj["FullObject"]["isFavorite"] = true;
      }else{
      obj["isFavorite"] = true;
      }
    })
    var object = {
      "files":this.universalService.selectedNodes,
      "operation":"SETFAV",
      "correlationId": USER_DETAILS["USER_DETAILS"]["userId"]
    }
    return object
  }

  removeFavorite(){
    this.universalService.selectedNodes.map(function(obj){
      if(obj["FullObject"]){
        obj["FullObject"]["isFavorite"] = false;
      }else{
        obj["isFavorite"] = false;
      }
    })
    var object = {
      "files":this.universalService.selectedNodes,
      "operation":"UNSETFAV",
      "correlationId": USER_DETAILS["USER_DETAILS"]["userId"]
    }
    return object
  }

  setShareObjects(apiResponse) {
    this.universalService.selectedNodes.map(item => {
      var obj = item["FullObject"] ? item["FullObject"]:item;
      obj['shareKey'] = apiResponse.shareKey;
      obj['shareLink'] = apiResponse.shareLink;
      obj['isShared'] = apiResponse.isShared;
      obj['shareType'] = apiResponse.shareType;
      obj['recipientsObjRights'] = this.universalService.recipientsObjRights;
    });
    this.copyShareText(apiResponse.shareLink, false);
    this.universalService.showLoader = false;
  }

  copyShareText(shareLink, isFirstGetLink) {
    var self = this;
    setTimeout(function() {
      if ( navigator.permissions == undefined) {
        const el = document.createElement("input");
        document.body.appendChild(el);
        el.value = shareLink;
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        self.universalService.showToast("Link copied successfully.", "success");
      }
      else{
        navigator.clipboard.writeText(shareLink).then(function() {
          /* clipboard successfully set */
          self.universalService.showViewButton = false;
          if(isFirstGetLink == true) {
            self.universalService.showToast(TOAST["FIRST_GET_LINK"], "success");
          } else {
            self.universalService.showToast(TOAST["COPY_LINK_SUCCESS"], "success");
          }
        }, function() {
          /* clipboard write failed */
          self.universalService.showToast(TOAST["COPY_LINK_FAILURE"], "error");
        });
      }
    });
  }

  getModuleType(obj){
    if(this.universalService.showPreview && obj?.previewFromUpload){
      return this.getModuleForPreviewFromUpload(obj);
    }
    var object={};
    if(this.universalService.selectedTab == "teamfolders" || this.router.url.includes('search/tf')){
      object["moduleType"] = "teamfolder";
      object["tfKey"] = obj["tfKey"];
      object["version"] = obj["version"];
    }else if(obj["shareType"] == "R"){
      object["moduleType"] = "share";
      object["shareKey"] = obj["shareKey"];
      object["version"] = obj["version"];
    }else if(this.universalService.selectedTab == "Album Details" || window.location.href.includes("/favorites/myalbums")){
      object["moduleType"] = "albums";
      object["boardKey"] = obj["boardKey"];
      object["version"] = obj["version"];
    }else{
      object["moduleType"] = "repo";
      object["objectKey"] = obj["objectKey"];
      object["version"] = obj["version"];
    }
    object["objectKey"] = object["objectKey"] ? object["objectKey"] :  obj["objectKey"];
    object = window.btoa(JSON.stringify(object))
    return object;
  }


  getModuleForPreviewFromUpload(obj){
    var object={};
    let uploadInitiatedModule = obj["uploadInitiatedModule"];
    if(uploadInitiatedModule == "teamfolders"){
      object["moduleType"] = "teamfolder";
      object["tfKey"] = obj["tfKey"];
      object["version"] = obj["version"];
    }else if(obj["shareType"] == "R"){
      object["moduleType"] = "share";
      object["shareKey"] = obj["shareKey"];
      object["version"] = obj["version"];
    }else if(uploadInitiatedModule == "Album Details"){
      object["moduleType"] = "albums";
      object["boardKey"] = obj["boardKey"];
      object["version"] = obj["version"];
    }else{
      object["moduleType"] = "repo";
      object["objectKey"] = obj["objectKey"];
      object["version"] = obj["version"];
    }
    object["objectKey"] = object["objectKey"] ? object["objectKey"] :  obj["objectKey"];
    object = window.btoa(JSON.stringify(object))
    return object;
  }


  setModuleDataForSavingTheEditedObject(file,object,saveLocation){
    let currentRoute = this.router.url;
    let queryParamsInRoute = this.activatedRoute.snapshot.queryParams;
    let currentTab = this.universalService.selectedTab;
    if(this.universalService.selectedTab == "Album Details" || this.universalService.selectedTab == "Favorites" || this.universalService.selectedTab == 'SearchResults' || this.universalService.selectedTab == 'AISearchResults' || this.universalService.selectedTab == 'TeamFolderSearchResults' || this.universalService.selectedTab == "SearchResultsDetailed" || this.universalService.selectedTab == "VideoSearchResultsDetailed" || this.universalService.selectedTab == "PhotoSearchResultsDetailed" || this.router.url.includes("/recents") || this.universalService.currentTab == "Person Details"){
      saveLocation = undefined;
      
      if(this.router.url.includes('/recents')){
        currentTab = "Recents";
      }else if(this.router.url.includes('/people/face')){
        currentTab = "Person Details";
      }
    }
    if(!saveLocation){
      switch(currentTab){
        case "Private Folder":
          saveLocation = {
            "objectKey" : this.localStorageService.getPrivateFolderKey()
          }
          break;
        case "Album Details":
          saveLocation = {
            "albumKey" : this.universalService.currentAlbum["boardKey"]
          }
          break;
        case "Favorites":
        case "SearchResults":
        case "AISearchResults":
        case "TeamFolderSearchResults":
        case "SearchResultsDetailed":
        case "Recents":
        case "Person Details":
          saveLocation = {
            "objectKey" : file["parentObjectKey"],
            "currentOpenedLocationAndUploadLocationDifferent" : true
          }
          break;
        default :
          saveLocation = {
            objectKey : USER_DETAILS["USER_DETAILS"]["rootFolderKey"]
          }
      }
    }else{
      saveLocation = {
        objectKey : saveLocation["objectKey"],
        shareKey : saveLocation["shareKey"]
      }
    }

    let destinationFolder = {...saveLocation};
    if(destinationFolder["currentOpenedLocationAndUploadLocationDifferent"]){
      currentRoute = "/allfiles/" + file["parentObjectKey"];
      queryParamsInRoute = null;
    }
    object = JSON.parse(window.atob(object));
    object["destinationFolderForUpload"] = destinationFolder;
    object["locationOfEdit"] = this.universalService.selectedTab;
    object["editInititateRoute"] = window.location.href.includes("/favorites/myalbums") ? "/favorites/myalbums" : this.router.url.split('?')[0]; // in favorites we are not reloading the component multiple times, we are updating only the history and not the route
    object["editInititatedQueryParams"] = this.activatedRoute.snapshot.queryParams;
    object["redirectToRouteAfterSavingTheEdit"] = currentRoute;
    object["redirectToQueryParamsAfterSavingTheEdit"] = queryParamsInRoute;
    object = window.btoa(JSON.stringify(object))
    return object;
  }

  resetRequiredDataBeforeOpeningTheLocationOfSelectedFile(){
    this.universalService.selectedFile = undefined;
    // this.universalService.showJustifiedLayout = false;
    AppEvents.optionSelected.next({fileInfo: false});
    this.universalService.showPreview = false;
    this.universalService.isPreviewOpenFromSearchDropdown = false;
    this.universalService.disableModalBackdrop();
  }
}
